

export type BoxSize = {
    width       : number
    height      : number
}

export default function getScreenSize():BoxSize {

    const width = document.body.offsetWidth;
    const height = document.body.offsetHeight;

    return {
        width   : width,
        height  : height
    }
}
